import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import { Button, withStyles, Tooltip } from '@material-ui/core';
import Proptypes from 'prop-types';
import { Alert } from '@material-ui/lab';
import notify from 'actions/notify';
import { useDispatch } from 'react-redux';
import getHelpfulErrorMessage from 'utils/getHelpfulErrorMessage';
import { get } from 'lodash';
import isEngineeringSupport from 'app/config/isEngineeringSupport';

const RERUN_PORTAL_FORM_SUBMISSION = gql`
  mutation rerunPortalFormSubmission($id: String) {
    rerunPortalFormSubmission(id: $id) {
      message
      success
    }
  }
`;

const RerunPortalFormSubmission = ({ classes, id, currentUser }) => {
  const [isRerunning, setIsRerunning] = useState(false);
  const [formError, setFormError] = useState(null);
  const dispatch = useDispatch();

  const [rerunPortalFormSubmission, { error }] = useMutation(
    RERUN_PORTAL_FORM_SUBMISSION,
    {
      onCompleted: (data) => {
        const { message, success } = data.rerunPortalFormSubmission;
        if (success) {
          dispatch(notify({ message }));
        } else {
          setFormError(message);
        }
        setIsRerunning(false);
      },
    },
  );

  const rerunPortalForm = () => {
    setFormError(null);
    setIsRerunning(true);
    rerunPortalFormSubmission({ variables: { id } });
  };

  const userEmail = get(currentUser.currentUser, 'email');
  const isEngineeringSupportEmail = isEngineeringSupport(userEmail);

  return (
    <div className={classes.buttonAndError}>
      <div>
        {(formError || error) && (
          <Alert className={classes.alert} severity="error">
            {formError || getHelpfulErrorMessage(error)}
          </Alert>
        )}
      </div>
      <div>
        <Tooltip
          title={
            !isEngineeringSupportEmail ? "You don't have permission to rerun forms." : ''
          }
          placement="top"
          disableFocusListener
          disableTouchListener
        >
          <span>
            <Button
              variant="contained"
              color="primary"
              onClick={() => rerunPortalForm()}
              disabled={isRerunning || !isEngineeringSupportEmail}
            >
              Rerun
            </Button>
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

const styles = (theme) => ({
  alert: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  buttonAndError: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: theme.spacing(1),
  },
});

RerunPortalFormSubmission.propTypes = {
  id: Proptypes.string.isRequired,
  currentUser: Proptypes.object.isRequired,
};

export default withStyles(styles)(RerunPortalFormSubmission);
